import React, { } from 'react';
import { animated, useSpring } from 'react-spring';
import Lottie from 'lottie-react';
import animationData from '../animation_json/hRodvl1dX9.json';
import "./HomePage.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useInView } from 'react-intersection-observer'; // Import useInView

import tabImg from "../Images/tab.png";
import logo from "../Images/logo.png";
import whatsappIcon from "../Images/WhatsApp.png";
import Navbar from "../Navigationbar/Navigation";
import Contacts from "../ContactMe/ContactMe";
import SlidingTextAnimation from "../animation_json/textAnimation";
import mobileImg from "../Images/mobileApp.png";
import iphoneImg from "../Images/phone.png";
import redLapImg from "../Images/lapR.png";
import otherImg from "../Images/otherR.png";
import webApp from "../Images/webApp.png";
import arrowIcon from "../Images/ArrowIcon.png";
import TechImg from "../Images/tech_images/techImg.png";
import TechImgM from "../Images/tech_images/techImgM.png";

import MediaQuery from 'react-responsive';

function Homepage() {
    const [sectionTwoRef, sectionTwoInView] = useInView({ threshold: 0.5 }); // Hook for secTwo visibility
    const [sectionThreeRef, sectionThreeInView] = useInView({ threshold: 0.2 }); // Hook for secThree visibility
    const [sectionFourRef, sectionFourInView] = useInView({ threshold: 0.2 }); // Hook for secFour visibility 
    const [sectionFiveRef, sectionFiveInView] = useInView({ threshold: 0.2 }); // Hook for secFive visibility
    const [sectionSixRef, sectionSixInView] = useInView({ threshold: 0.4 }); // Hook for secSix visibility
    const [sectionSevenRef, sectionSevenInView] = useInView({ threshold: 0.1 }); // Hook for secSix visibility

    // Animation for secTwo
    const sectionTwoAnimation = useSpring({
        transform: sectionTwoInView ? 'translateY(0px)' : 'translateY(50px)',
        opacity: sectionTwoInView ? 1 : 0,
        config: { duration: 1000 },
    });

    // Animation for secThree
    const sectionThreeAnimation = useSpring({
        transform: sectionThreeInView ? 'translateY(0px)' : 'translateY(50px)',
        opacity: sectionThreeInView ? 1 : 0,
        config: { duration: 1000 },
    });

    // Animation for secFour
    const sectionFourAnimation = useSpring({
        transform: sectionFourInView ? 'translateY(0px)' : 'translateY(50px)',
        opacity: sectionFourInView ? 1 : 0,
        config: { duration: 1000 },
    });

    // Animation for secFive
    const sectionFiveAnimation = useSpring({
        transform: sectionFiveInView ? 'translateY(0px)' : 'translateY(50px)',
        opacity: sectionFiveInView ? 1 : 0,
        config: { duration: 1000 },
    });

    // Animation for secSix
    const sectionSixAnimation = useSpring({
        transform: sectionSixInView ? 'translateY(0px)' : 'translateY(50px)',
        opacity: sectionSixInView ? 1 : 0,
        config: { duration: 1000 },
    });

    // Animation for secSeven
    const sectionSevenAnimation = useSpring({
        transform: sectionSevenInView ? 'translateY(0px)' : 'translateY(50px)',
        opacity: sectionSevenInView ? 1 : 0,
        config: { duration: 1000 },
    });


    // Animation for the entire page
    const sectionAnimation = useSpring({
        from: { opacity: 0, transform: 'translateY(50px)' },
        to: { opacity: 1, transform: 'translateY(0px)' },
        config: { duration: 1000 },
    });

    // Function to initiate a phone call
    const makePhoneCall = () => {
        const phoneNumber = '+971543957306'; // Updated phone number with country code
        window.location.href = `tel:${phoneNumber}`;
    };

    const handleEmailClick = () => {
        window.location.href = 'mailto:isurunirash@gmail.com';
    };

    const readMoreButtonClick = () => {
        window.open('https://www.behance.net/gallery/193153843/The-Power-of-Virtual-Interior-Decor', '_blank');
    };

    const webReadMoreButtonClick = () => {
        window.open('https://www.behance.net/gallery/192445447/CareerMatch-Connect', '_blank');
    };

    const viewMoreButtonClick = () => {
        window.open('https://www.behance.net/Isuru_Nirash', '_blank');
    };


    return (
        <React.Fragment>
            <section className="body" id="landingPage">
                <span className="centered-navbar">
                    <Navbar />
                </span>
                <animated.section className="secOne" style={sectionAnimation}>
                    <Lottie className="mblB" style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} animationData={animationData} />
                    <div className="overlay"></div>
                    <div className="header-container d-flex justify-content-between align-items-center">
                        <span><img src={logo} alt="logo" className="logo" /></span>
                        <button className="whatsappbtn" style={{ width: '190px', height: '65px' }} onClick={makePhoneCall}>
                            <img src={whatsappIcon} alt="WhatsApp" style={{ width: '24px', height: '24px' }} />
                            <span className="whatsappImg" style={{ marginLeft: '10px' }}>Schedule a Call</span>
                        </button>
                    </div>

                    <div className="tabImg-container">
                        <div className="">
                            <span className="mainTitle">Innovative Design  Strategy & <br></br>Development & More <br></br>In-House Expertise.</span>
                        </div>
                        <div className="">
                            <button className="emailButton" onClick={handleEmailClick}>Get in Touch</button>
                            <img className="tabImg" src={tabImg} alt="tabImg" style={{ width: '800px' }} />
                        </div>
                    </div>
                </animated.section>
            </section>

            <MediaQuery minDeviceWidth={1224} values={{ deviceWidth: 1600 }}>
                <section className="secTwo" id="secTwo" ref={sectionTwoRef}>
                    <animated.div className="d-flex justify-content-between" style={sectionTwoAnimation}>
                        <div className="description" style={{ width: '40%' }}>
                            <p>Visualize, customize dream spaces with color, furniture, templates.</p>
                            <div className="tags">
                                <span>UI/UX</span>
                                <span>Design</span>
                                <span>Figma</span>
                                <span>Ux Case Study</span>
                                <span>Mobile Application</span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                                <button className="readMoreButton" style={{ width: '190px', height: '65px' }} onClick={readMoreButtonClick}>
                                    Read More
                                <img src={arrowIcon} alt="arrowIcon" className="rotated-arrow" style={{ width: '17px', height: 'auto' }} />
                                </button>
                            </div>
                        </div>
                        <div className="image" style={{ width: '60%' }}>
                            <img src={mobileImg} alt="mobileImg" style={{ width: '100%', height: 'auto' }} />
                        </div>
                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery maxDeviceWidth={1224}>
                <section className="secTwo" id="secTwo" ref={sectionTwoRef}>
                    <animated.div className="d-flex flex-row" style={sectionTwoAnimation}>
                        <div className="description" style={{ width: '100%' }}>
                            <div className="image" style={{ width: '100%' }}>
                                <img src={mobileImg} alt="mobileImg" style={{ width: '100%', height: 'auto' }} />
                            </div>
                            <p>Visualize, customize dream spaces with color, furniture, templates.</p>
                            <div className="tags">
                                <span>UI/UX</span>
                                <span>Design</span>
                                <span>Figma</span>
                                <span>Ux Case Study</span>
                                <span>Mobile Application</span>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                                <button className="readMoreButton" style={{ width: '190px', height: '65px' }} onClick={readMoreButtonClick}>
                                    Read More
                                <img src={arrowIcon} alt="arrowIcon" className="rotated-arrow" style={{ width: '17px', height: 'auto' }} />
                                </button>
                            </div>
                        </div>
                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery minDeviceWidth={1224} values={{ deviceWidth: 1600 }}>
                <section className="secThree" ref={sectionThreeRef}>
                    <animated.div style={sectionThreeAnimation}>
                        <div className="d-flex justify-content-between" >
                            <div className="description" style={{ width: '40%' }}>
                                <p>Visualize, customize dream spaces with color, furniture, templates.</p>
                                <div className="tags">
                                    <span>UI/UX</span>
                                    <span>Design</span>
                                    <span>Job Hunt</span>
                                    <span>Figma</span>
                                    <span>UX research</span>
                                    <span>Web Application</span>
                                    <span>Case Study</span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                    <button className="readMoreButton" style={{ width: '190px', height: '65px' }} onClick={webReadMoreButtonClick}>
                                        Read More
                                <img src={arrowIcon} alt="arrowIcon" className="rotated-arrow" style={{ width: '17px', height: 'auto' }} />
                                    </button>
                                </div>
                            </div>
                            <div className="image" style={{ width: '60%' }}>
                                <img src={webApp} alt="webAppImg" style={{ width: '100%', height: 'auto' }} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                            <button className="viewMoreButton" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                View More
                        </button>
                        </div>
                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery maxDeviceWidth={1224}>
                <section className="secThree" ref={sectionThreeRef}>
                    <animated.div className="d-flex flex-row" style={sectionThreeAnimation}>
                        <div className="d-flex" >
                            <div className="description" style={{ width: '100%' }}>
                                <div className="image" style={{ width: '100%' }}>
                                    <img src={webApp} alt="webAppImg" style={{ width: '100%', height: 'auto' }} />
                                </div>
                                <p>Visualize, customize dream spaces with color, furniture, templates.</p>
                                <div className="tags">
                                    <span>UI/UX</span>
                                    <span>Design</span>
                                    <span>Job Hunt</span>
                                    <span>Figma</span>
                                    <span>UX research</span>
                                    <span>Web Application</span>
                                    <span>Case Study</span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center">
                                    <button className="readMoreButton" style={{ width: '190px', height: '65px' }} onClick={webReadMoreButtonClick}>
                                        Read More
                                <img src={arrowIcon} alt="arrowIcon" className="rotated-arrow" style={{ width: '17px', height: 'auto' }} />
                                    </button>
                                </div>
                                <div className="d-flex justify-content-center">
                                    <button className="viewMoreButton" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                        View More
                        </button>
                                </div>
                            </div>
                        </div>

                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery minDeviceWidth={1224} values={{ deviceWidth: 1600 }}>
                <section className="secFive" id="secFive" ref={sectionFiveRef}>
                    <animated.div style={sectionFiveAnimation}>
                        <div class="d-flex flex-column">

                            <div className="capabilities">
                                <h2>My Capabilities</h2>
                                <p>As a UI/UX designer and frontend developer, I excel in creating intuitive interfaces with a focus on user experience. My skills encompass designing visually appealing layouts, crafting seamless user interactions, and implementing responsive and accessible frontend code. I bring a blend of design and development expertise to deliver exceptional digital experiences.</p>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div className="secFiveImage" style={{ width: '40%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <h2 className="fiveTitle" style={{ marginBottom: '-60px' }}>Mobile App<br></br>Design UI/UX & Research</h2>
                                    <img className="imageAnimation" src={iphoneImg} alt="iphoneImg" style={{ maxWidth: '100%', height: 'auto', margin: '0' }} />
                                </div>

                                <div className="secFiveContent" style={{ width: '60%' }}>
                                    <p>Mobile app UI/UX design integrates user research via personas, interviews, and competitor analysis. Information architecture and wireframing establish the app's structure, while prototyping refines functionality. Visual design aligns with branding and undergoes usability testing for improvements. An iterative process based on user and stakeholder feedback ensures a responsive, intuitive interface. This holistic approach results in a user-centered mobile app design that enhances overall usability and user satisfaction.</p>

                                    <div className="d-flex justify-content-left">
                                        <button className="explorebtn" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                            Explore More
                                    </button>
                                    </div>
                                </div>
                            </div>

                            <div className="bottomLine"></div>

                            <div className="d-flex justify-content-between">
                                <div className="secFiveImage" style={{ width: '40%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <h2 className="fiveTitle" style={{ marginBottom: '-60px' }}>Website<br></br>Design & Development</h2>
                                    <img className="imageAnimationOpposite" src={redLapImg} alt="redLapImg" style={{ maxWidth: '100%', height: 'auto', margin: '0' }} />
                                </div>

                                <div className="secFiveContent" style={{ width: '60%' }}>
                                    <p>As a professional in website design and development, I specialize in creating visually captivating and user-friendly interfaces. My skills include designing aesthetically pleasing layouts, optimizing user experience, and implementing responsive and efficient frontend code. I also excel in backend development, database management, and ensuring overall website performance, resulting in compelling and functional online experiences for users.</p>

                                    <div className="d-flex justify-content-left">
                                        <button className="explorebtn" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                            Explore More
                                    </button>
                                    </div>
                                </div>
                            </div>

                            <div className="bottomLine"></div>

                            <div className="d-flex justify-content-between">
                                <div className="secFiveImage" style={{ width: '40%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <h2 className="fiveTitle" style={{ marginBottom: '-60px' }}>Content Strategy and <br></br>Creation</h2>
                                    <img className="imageAnimation" src={otherImg} alt="otherImg" style={{ maxWidth: '100%', height: 'auto', margin: '0' }} />
                                </div>

                                <div className="secFiveContent" style={{ width: '60%' }}>
                                    <p>Specializing in project management, search engine optimization (SEO), and UI/UX research, I excel in overseeing project lifecycles, optimizing websites for search engines, and conducting user-centric research. My skills include developing project plans, implementing SEO strategies for increased visibility, and crafting intuitive user interfaces based on thorough research and analysis. By integrating these disciplines, I ensure successful projects that meet user needs and achieve business objectives effectively.</p>

                                    <div className="d-flex justify-content-left">
                                        <button className="explorebtn" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                            Explore More
                                    </button>
                                    </div>
                                </div>
                            </div>
                            <div className="bottomLine"></div>
                        </div>
                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery maxDeviceWidth={1224}>
                <section className="secFive" id="secFive" ref={sectionFiveRef}>
                    <animated.div style={sectionFiveAnimation}>
                        <div class="">
                            <div className="capabilities">
                                <h2>My Capabilities</h2>
                                <p>As a UI/UX designer and frontend developer, I excel in creating intuitive interfaces with a focus on user experience. My skills encompass designing visually appealing layouts, crafting seamless user interactions, and implementing responsive and accessible frontend code. I bring a blend of design and development expertise to deliver exceptional digital experiences.</p>
                            </div>
                            <div className="">
                                <img className="imageAnimation" src={iphoneImg} alt="iphoneImg" style={{ width: '100%', height: 'auto', margin: '0' }} />
                                <div className="secFiveImage" style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <h2 className="fiveTitle" style={{ marginBottom: '10px', marginLeft: '10px' }}>Mobile App<br></br>Design UI/UX & Research</h2>
                                </div>

                                <div className="secFiveContent" style={{ width: '100%' }}>
                                    <p>Mobile app UI/UX design integrates user research via personas, interviews, and competitor analysis. Information architecture and wireframing establish the app's structure, while prototyping refines functionality. Visual design aligns with branding and undergoes usability testing for improvements. An iterative process based on user and stakeholder feedback ensures a responsive, intuitive interface. This holistic approach results in a user-centered mobile app design that enhances overall usability and user satisfaction.</p>
                                    <div className="">
                                        <button className="explorebtn" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                            Explore More
                                    </button>
                                    </div>
                                </div>
                            </div>

                            <div className="bottomLine"></div>

                            <div className="">
                                <img className="imageAnimationOpposite" src={redLapImg} alt="redLapImg" style={{ maxWidth: '100%', height: 'auto', margin: '0' }} />
                                <div className="secFiveImage" style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <h2 className="fiveTitle" style={{ marginBottom: '10px', marginLeft: '10px' }}>Website<br></br>Design & Development</h2>
                                </div>

                                <div className="secFiveContent" style={{ width: '100%' }}>
                                    <p>As a professional in website design and development, I specialize in creating visually captivating and user-friendly interfaces. My skills include designing aesthetically pleasing layouts, optimizing user experience, and implementing responsive and efficient frontend code. I also excel in backend development, database management, and ensuring overall website performance, resulting in compelling and functional online experiences for users.</p>

                                    <div className=" ">
                                        <button className="explorebtn" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                            Explore More
                                    </button>
                                    </div>
                                </div>
                            </div>

                            <div className="bottomLine"></div>

                            <div className=" ">
                                <img className="imageAnimation" src={otherImg} alt="otherImg" style={{ maxWidth: '100%', height: 'auto', margin: '0' }} />
                                <div className="secFiveImage" style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                    <h2 className="fiveTitle" style={{ marginBottom: '10px', marginLeft: '10px' }}>Content Strategy and <br></br>Creation</h2>

                                </div>

                                <div className="secFiveContent" style={{ width: '100%' }}>
                                    <p>Specializing in project management, search engine optimization (SEO), and UI/UX research, I excel in overseeing project lifecycles, optimizing websites for search engines, and conducting user-centric research. My skills include developing project plans, implementing SEO strategies for increased visibility, and crafting intuitive user interfaces based on thorough research and analysis. By integrating these disciplines, I ensure successful projects that meet user needs and achieve business objectives effectively.</p>

                                    <div className=" ">
                                        <button className="explorebtn" style={{ width: '190px', height: '65px' }} onClick={viewMoreButtonClick}>
                                            Explore More
                                    </button>
                                    </div>
                                </div>
                            </div>
                            <div className="bottomLine"></div>
                        </div>
                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery minDeviceWidth={1224} values={{ deviceWidth: 1600 }}>
                <section className="secSix" id="technologiesSection" ref={sectionSixRef}>
                    <animated.div style={sectionSixAnimation}>
                        <div className="secSixContainer" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img className="imageAnimationLeftRight" src={TechImg} alt="TechImg" style={{ width: '1300px', height: 'auto', margin: '0' }} />
                            <div className="sixContent">
                                <h2>Technologies</h2>
                            </div>
                        </div>
                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery maxDeviceWidth={1224}>
                <section className="secSix" id="technologiesSection" ref={sectionSixRef}>
                    <animated.div style={sectionSixAnimation}>
                        <div className="sixContent secSixContainer">
                            <h2>Technologies</h2>
                        </div>
                        <div className="" style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <img className="" src={TechImgM} alt="TechImgM" style={{ width: '100%', height: 'auto', margin: '0' }} />
                        </div>
                    </animated.div>
                </section>
            </MediaQuery>

            <section className="secFour" id="aboutMeSection" ref={sectionFourRef}>
                <animated.div style={sectionFourAnimation}>
                    <div className="d-flex justify-content-center flex-column paddingLeftRight pt-20 pb-98" >
                        <h2>About Me</h2>
                        <h4>Isuru Nirash</h4>
                        <p>I am a passionate UI/UX designer and front-end developer with a proven track record of creating intuitive and visually appealing digital experiences. With a keen eye for detail and a strong understanding of user-centered design principles, I specialize in crafting seamless and delightful interactions that captivate users and drive engagement.

                        In my career, I have collaborated with cross-functional teams to conceptualize, design, and develop user interfaces for web and mobile applications across various industries. I excel in translating user needs and business goals into elegant design solutions that enhance usability and overall user satisfaction.

                        I believe in the power of design to solve complex problems and create meaningful connections between users and products. My design approach is user-centric, data-driven, and focused on delivering delightful experiences that resonate with target audiences.</p>
                    </div>
                </animated.div>

                <SlidingTextAnimation />
            </section>

            <MediaQuery minDeviceWidth={1224} values={{ deviceWidth: 1600 }}>
                <section className="secSeven" id="contactMeSec" ref={sectionSevenRef}>
                    <animated.div style={sectionSevenAnimation}>
                        <Contacts />
                    </animated.div>
                </section>
            </MediaQuery>

            <MediaQuery maxDeviceWidth={1224}>
                <section className="secSeven" id="contactMeSec" ref={sectionSevenRef}>
                    <animated.div style={sectionSevenAnimation}>
                        <Contacts />
                    </animated.div>
                </section>
            </MediaQuery>

        </React.Fragment>
    );
}

export default Homepage;
